import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { AdminPage, EmptyState } from '../../../components/design-system/admin';

/** An address the super-admin portal does not have (it used to render a blank page). */
export const AdminNotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <AdminPage title={t('ADMIN_SHELL.COMMON.NOT_FOUND_TITLE')} header={<span />}>
      <EmptyState
        icon={<Compass />}
        title={t('ADMIN_SHELL.COMMON.NOT_FOUND_TITLE')}
        description={t('ADMIN_SHELL.COMMON.NOT_FOUND_BODY')}
        action={
          <Button variant="outline" asChild>
            <Link to="/dashboard">{t('ADMIN_SHELL.COMMON.BACK_TO_OVERVIEW')}</Link>
          </Button>
        }
        className="py-24"
      />
    </AdminPage>
  );
};

export default AdminNotFoundPage;
